import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      fill="none"
      viewBox="0 0 10 6"
    >
      <path
        fill="#0AA1F4"
        d="M5 2.182L1.11 6 0 4.91 5 0l5 4.91L8.89 6 5 2.182z"
      ></path>
    </svg>
  )
}

export default Icon
